// CurrencyIcon component

import React from 'react'
import PropTypes from 'prop-types'

const CurrencyIcon = ({ currency, className }) => (
  <span className='currency_icon'>
    <p className={`${className}`}>{currency}</p>
  </span>
)

CurrencyIcon.propTypes = {
  currency: PropTypes.string,
  className: PropTypes.string
}

CurrencyIcon.defaultProps = {
  currency: '€',
  className: 'EUR'
}

export default CurrencyIcon
